/**
 * zen-fs-webdav
 * 一个简单、现代的 WebDAV 客户端库，提供类似文件系统的 API
 */

// 导出主类
export { WebDAVFileSystem } from './WebDAVFileSystem';
export { createWebDAVFileSystem } from './webdav';

// 导出错误类
export { WebDAVError } from './errors';

// 导出类型定义
export {
  WebDAVOptions,
  WebDAVRequestOptions,
  FileEntry,
  Stats,
  ReadFileOptions,
  WriteFileOptions,
  MkdirOptions,
  RmdirOptions,
  ReaddirOptions,
  CopyOptions,
  MoveOptions,
} from './types';

// 导出工具函数（例如 parseWebDAVXml）以便其它包可以直接使用
export { parseWebDAVXml } from './utils';
// 导出 GM 适配器，方便 userscript 使用
export { gmHttpClient, gmRequestAdapter } from './gm-adapter';

// 导出调试控制接口（基于 @richard432/localstorage-logger，缺省关闭）
export {
  setDebugEnabled,
  isDebugEnabled,
  enableDebug,
  disableDebug,
  listDebugModulesNames as listDebugModules,
  MODULE as DEBUG_MODULE,
} from './debug';

// 导出 zen-fs-sync 兼容适配器（SyncableFS 接口实现）
export { SyncableWebDAVFS } from './syncable-webdav-fs';
